var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.99 109.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#80D4FF;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Performance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96,94.63h0a1.78,1.78,0,0,1-1.26-.53L60.85,60a1.81,1.81,0,0,1-.52-1.26v-.47a1.78,1.78,0,0,1,1.78-1.78h48.1A1.77,1.77,0,0,1,112,58.23v.48a49.56,49.56,0,0,1-14.72,35.4A1.8,1.8,0,0,1,96,94.63ZM65.92,60,96,90.31A46,46,0,0,0,108.42,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.88,109.52a49.88,49.88,0,0,1,0-99.75h0a1.78,1.78,0,0,1,1.78,1.78V58.9L85,92.51a1.76,1.76,0,0,1,.51,1.26A1.81,1.81,0,0,1,85,95,49.55,49.55,0,0,1,49.88,109.52Zm-1.8-96.16A46.32,46.32,0,1,0,81.24,93.73L48.61,60.9a1.8,1.8,0,0,1-.51-1.24v-.25a1.94,1.94,0,0,1,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.56,51.19H58.45a1.78,1.78,0,0,1-1.78-1.78V1.78A1.78,1.78,0,0,1,58.45,0h0a50,50,0,0,1,49.87,49.39,1.79,1.79,0,0,1-1.78,1.8ZM60.23,47.63h44.5a46.49,46.49,0,0,0-44.5-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.89,58.16a1.82,1.82,0,0,1-1.26-.52,1.79,1.79,0,0,1,0-2.52L45.35,10.4a1.78,1.78,0,1,1,2.51,2.52L3.15,57.64A1.8,1.8,0,0,1,1.89,58.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.4,73.84a1.76,1.76,0,0,1-1.26-.52,1.79,1.79,0,0,1,0-2.52L48.6,24.34a1.78,1.78,0,0,1,2.52,2.52L4.66,73.32A1.78,1.78,0,0,1,3.4,73.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.49,85.94a1.76,1.76,0,0,1-1.26-.52,1.79,1.79,0,0,1,0-2.52L48.6,41.53a1.78,1.78,0,0,1,2.52,2.52L9.75,85.42A1.78,1.78,0,0,1,8.49,85.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,95.59a1.76,1.76,0,0,1-1.26-.52,1.78,1.78,0,0,1,0-2.51l34-34a1.77,1.77,0,0,1,2.51,2.51l-34,34A1.74,1.74,0,0,1,16,95.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.76,103.05a1.76,1.76,0,0,1-1.26-.52,1.79,1.79,0,0,1,0-2.52L57.35,67.17a1.78,1.78,0,0,1,2.51,2.52L27,102.53A1.76,1.76,0,0,1,25.76,103.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,108a1.8,1.8,0,0,1-1.26-.52,1.77,1.77,0,0,1,0-2.52l29.2-29.21a1.78,1.78,0,0,1,2.52,2.52L39.22,107.52A1.78,1.78,0,0,1,38,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.83,109.36a1.76,1.76,0,0,1-1.26-.52,1.78,1.78,0,0,1,0-2.51L74.48,84.42A1.77,1.77,0,0,1,77,86.93l-21.9,21.91A1.78,1.78,0,0,1,53.83,109.36Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/Performance.4a15d7d603abddcd567f3c68a089da4f.svg";
export { ForwardRef as ReactComponent };